$eve_switch $eve_input_logical_switch
